
<section class="row row-cols-2 row-cols-md-3 row-cols-xl-4">


  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>


  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

  <div class="field col-12 md:col-6 md:pr-6 pr-0">
      <div class="custom-skeleton p-4">
          <p-skeleton width="100%" height="150px"></p-skeleton>
          <div class="align-items-center d-flex flex-column flex-sm-row gap-2 gap-sm-0 justify-content-between mt-3">
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
          </div>
      </div>
  </div>

</section>
